import React from 'react';

import { CellContext } from '@tanstack/react-table';

import { EntityReference } from '@hud/portal-dtos/webapp-common.dto';
import {
  EntitiesPopover,
  EntitiesPopoverProps,
} from '../EntitiesPopover/EntitiesPopover';

export function entitiesCellRenderer(
  entityType: EntitiesPopoverProps['entityType'],
) {
  return function cellRenderer<TData, TValue>(
    cell: CellContext<TData, TValue>,
  ) {
    const obj = cell.row.original as Record<
      EntitiesPopoverProps['entityType'],
      EntityReference[]
    >;
    let entities = obj?.[entityType];
    // if entities is a single entity, convert it to an array
    if (entities && !Array.isArray(entities)) {
      entities = [entities];
    }
    return <EntitiesPopover entities={entities} entityType={entityType} />;
  };
}

export function entitiesCellFormatter(
  entityType: EntitiesPopoverProps['entityType'],
) {
  return function cellRenderer<TData, TValue>(
    cell: CellContext<TData, TValue>,
  ) {
    const obj = cell.row.original as Record<
      EntitiesPopoverProps['entityType'],
      EntityReference[]
    >;
    const entities = obj?.[entityType];
    return entities.length === 1
      ? entities[0].name
      : entities.length.toString();
  };
}
